<template>
  <div id="global" class="global global-padding pt-0">
    <div class="container">
      <div
        class="head d-flex flex-column justify-content-center align-items-center gap-4"
      >
        <h3 class="heading">Corporate Companies</h3>
        <p class="text-center w-75">
          Aljabiri Group’s corporate footprint across key markets. Explore our
          subsidiaries and operating companies by region and focus
        </p>
      </div>

      <div
        class="tab d-flex flex-column justify-content-center align-items-center gap-5"
      >
        <div class="network w-fit d-flex gap-2 align-items-center">
          <div class="global-icon">
            <!-- SVG icon هنا -->
          </div>

          <!-- Dynamic Tabs -->
          <ul class="nav nav-pills gap-2" id="pills-tab" role="tablist">
            <li
              v-for="(tab, index) in tabs"
              :key="tab.id"
              class="nav-item"
              role="presentation"
            >
              <button
                class="nav-link"
                :class="{ active: index === 0 }"
                :id="`${tab.id}-tab`"
                data-bs-toggle="pill"
                :data-bs-target="`#${tab.id}`"
                type="button"
                role="tab"
                :aria-controls="tab.id"
                :aria-selected="index === 0"
              >
                {{ tab.label }}
              </button>
            </li>
          </ul>
        </div>

        <!-- Dynamic Tab Content -->
        <div class="tab-content w-100" id="pills-tabContent">
          <div
            v-for="(tab, tabIndex) in tabs"
            :key="tab.id"
            class="tab-pane fade"
            :class="{ 'show active': tabIndex === 0 }"
            :id="tab.id"
            role="tabpanel"
            :aria-labelledby="`${tab.id}-tab`"
          >
            <!-- Filter Input -->
            <input
              v-model="tabFilters[tab.id]"
              type="text"
              placeholder="Filter by tag or title..."
              class="form-control mb-3"
            />

            <!-- Accordion Items -->
            <div
              v-for="(item, accIndex) in filteredAccordion(tab)"
              :key="accIndex"
              class="card mb-3"
              @mouseenter="hovered = accIndex"
              @mouseleave="hovered = null"
            >
              <h2
                class="d-flex align-items-center justify-content-between mb-0 gap-3"
              >
                <span class="p-0 d-flex align-items-center gap-2">
                  <img :src="item.icon" alt="icon" />
                  {{ item.title }}
                </span>
                <span class="tag" style="padding: 8px 16px">{{
                  item.tag
                }}</span>
              </h2>
              <transition name="fade">
                <p v-if="hovered === accIndex" class="mt-2 mb-0">
                  {{ item.description }}
                </p>
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from "vue";
import ScrollReveal from 'scrollreveal';

const hovered = ref(null);

// Filters لكل تاب
const tabFilters = reactive({});

// Tabs data
const tabs = [
  {
    id: "pills-global",
    label: "ALL",
    accordion: [
      {
        icon: "/images/bullet-red.svg",
        title: "Shanghai & Hong Kong, China",
        tag: "Asia–Pacific Gateway",
        description:
          "Aljabiri Group Investment Ltd Acts as Asia–Pacific gateways, providing access to Chinese and global markets, facilitating cross-border trade, and supporting investment partnerships.",
      },
      {
        icon: "/images/yellowBullet.svg",
        title: "Riyadh, Kingdom of Saudi Arabia",
        tag: "Holding HQ",
        description:
          "Aljabiri Group Investment Ltd Serves as the principal holding office and corporate command center, providing strategic direction, financial governance, and oversight of long-term growth.",
      },
      // {
      //   icon: "/images/yellowBullet.svg",
      //   title: "United Arab Emirates",
      //   tag: "E-Trading (Multi-Sector)",
      //   description:
      //     "One Technology FZ-LLC Specializes in multi-sector e-trading, including equipment, garments, household goods, media, vehicles, and portal-based services.",
      // },
      {
        icon: "/images/yellowBullet.svg",
        title: "Doha, Qatar",
        tag: "Regional Hub",
        description:
          "Aljabiri Group Investment Ltd Acts as a regional hub for cross-border partnerships, innovation-driven growth, and Gulf-centered investment alignment.",
      },
      {
        icon: "/images/yellowBullet.svg",
        title: "Muscat, Oman",
        tag: "Industrial & Government Ties",
        description:
          "Aljabiri Group Investment Ltd Strengthens ties with Gulf industries and government entities, with a focus on resource optimization and industrial collaboration.",
      },
      {
        icon: "/images/bullet-blue.svg",
        title: "Jordan",
        tag: "Investment & Advisory",
        description:
          "Cross-Jordan Company Leads regional investments, advisory services, and industrial initiatives connecting Levant markets with the Gulf and Asia.",
      },
      {
        icon: "/images/bullet-blue.svg",
        title: "Amman & Aqaba, Jordan",
        tag: "Green Tech / Healthcare",
        description:
          "PureSEEN Hawama Co. Ltd. A pioneer in green technologies, specializing in air and surface purification solutions for healthcare, hospitality, and industrial use.",
      },
      {
        icon: "/images/bullet-green.svg",
        title: "Cairo, Egypt",
        tag: "North Africa Hub",
        description:
          "Aljabiri Group Ltd Anchors the Group’s North African presence, supporting trade, real estate, and industrial expansion.",
      },
    ],
  },
  {
    id: "pills-asia",
    label: "Asia–Pacific",
    accordion: [
      {
        icon: "/images/bullet-red.svg",
        title: "Shanghai & Hong Kong, China",
        tag: "Asia–Pacific Gateway",
        description:
          "Aljabiri Group Investment Ltd Acts as Asia–Pacific gateways, providing access to Chinese and global markets, facilitating cross-border trade, and supporting investment partnerships.",
      },
    ],
  },
  {
    id: "pills-europe",
    label: "GCC",
    accordion: [
      {
        icon: "/images/yellowBullet.svg",
        title: "Riyadh, Kingdom of Saudi Arabia",
        tag: "Holding HQ",
        description:
          "Aljabiri Group Investment Ltd Serves as the principal holding office and corporate command center, providing strategic direction, financial governance, and oversight of long-term growth.",
      },
      // {
      //   icon: "/images/yellowBullet.svg",
      //   title: "United Arab Emirates",
      //   tag: "E-Trading (Multi-Sector)",
      //   description:
      //     "One Technology FZ-LLC Specializes in multi-sector e-trading, including equipment, garments, household goods, media, vehicles, and portal-based services.",
      // },
      {
        icon: "/images/yellowBullet.svg",
        title: "Doha, Qatar",
        tag: "Regional Hub",
        description:
          "Aljabiri Group Investment Ltd Acts as a regional hub for cross-border partnerships, innovation-driven growth, and Gulf-centered investment alignment.",
      },
      {
        icon: "/images/yellowBullet.svg",
        title: "Muscat, Oman",
        tag: "Industrial & Government Ties",
        description:
          "Aljabiri Group Investment Ltd Strengthens ties with Gulf industries and government entities, with a focus on resource optimization and industrial collaboration.",
      },
    ],
  },
  {
    id: "pills-east",
    label: "Levant",
    accordion: [
      {
        icon: "/images/bullet-blue.svg",
        title: "Jordan",
        tag: "Investment & Advisory",
        description:
          "Cross-Jordan Company Leads regional investments, advisory services, and industrial initiatives connecting Levant markets with the Gulf and Asia.",
      },
      {
        icon: "/images/bullet-blue.svg",
        title: "Amman & Aqaba, Jordan",
        tag: "Green Tech / Healthcare",
        description:
          "PureSEEN Hawama Co. Ltd. A pioneer in green technologies, specializing in air and surface purification solutions for healthcare, hospitality, and industrial use.",
      },
    ],
  },
  {
    id: "pills-North-Africa",
    label: "North Africa",
    accordion: [
      {
        icon: "/images/bullet-green.svg",
        title: "Cairo, Egypt",
        tag: "North Africa Hub",
        description:
          "Aljabiri Group Ltd Anchors the Group’s North African presence, supporting trade, real estate, and industrial expansion.",
      },
    ],
  },
  // {
  //   id: "pills-virtual",
  //   label: "Virtual",
  //   accordion: [
  //     {
  //       icon: "/images/bullet-online.svg",
  //       title: "Online Platforms",
  //       tag: "E-commerce",
  //       description:
  //         "We maintain a strong presence across several online platforms to ensure our food products reach consumers directly. Our registered and authorized stores are available on: Taobao, Alibaba, Redbook, TikTok, WeChat mini app, and Pinduoduo.",
  //     },
  //   ],
  // },
];

// دالة فلترة العناصر داخل كل تاب
const filteredAccordion = (tab) => {
  const filterText = (tabFilters[tab.id] || "").toLowerCase();
  if (!filterText) return tab.accordion;
  return tab.accordion.filter(
    (item) =>
      item.title.toLowerCase().includes(filterText) ||
      item.tag.toLowerCase().includes(filterText) ||
      item.description.toLowerCase().includes(filterText)
  );
};

onMounted(() => {
  const sr = ScrollReveal({
    origin: 'bottom',
    distance: '60px',
    duration: 1000,
    delay: 200,
    reset: false,
    easing: 'cubic-bezier(0.5, 0, 0, 1)'
  });

  // Animate the heading
  sr.reveal('.head h3', {
    origin: 'top',
    delay: 200,
    distance: '40px'
  });

  sr.reveal('.head p', {
    delay: 400,
    distance: '30px'
  });

  // Animate the tabs navigation
  sr.reveal('.network', {
    delay: 600,
    distance: '40px',
    scale: 0.9
  });

  // Animate the filter input
  sr.reveal('.form-control', {
    delay: 800,
    distance: '30px',
    opacity: 0
  });

  // Animate the cards with staggered effect
  sr.reveal('.card', {
    delay: 400,
    interval: 150,
    distance: '40px',
    scale: 0.95,
    opacity: 0
  });
});
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease-in-out;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.card {
  transition: all 0.3s ease-in-out;
}
.card:hover {
  border: 1px solid #ddb657;
}
.global-padding {
  padding-left: 80px;
  padding-right: 80px;
  padding-bottom: 80px;
}

/* Animation styles */
.head h3,
.head p,
.network,
.form-control,
.card {
  visibility: hidden;
}

.card {
  transition: all 0.3s ease-in-out;
}

@media (max-width: 767px) {
  .global-padding {
    padding-left: 50px;
    padding-right: 50px;
    padding-bottom: 80px;
  }
}
@media (max-width: 550px) {
  .global-padding {
    padding-left: 12px;
    padding-right: 12px;
    padding-bottom: 80px;
  }
}
</style>
